module.exports = new __parcel__URL__("retrospective.1a3389a9.svg").toString();